import { FORM_MENUS } from '@publishing/modules/forms/_config';
import { FORM_KEY, type FormKey } from '@publishing/modules/forms/_types';

import type { HubEvent } from './types';
import { getActiveEvents } from './eventStatus';

// ── 1depth 탭 카테고리 (UI 표시 라벨)
export const TAB = {
  ALL:    '전체',
  OFFICE: '공유오피스',
  BUILD:  '사무실 구축',
  SOLO:   '1인 전용 상품',
} as const;

export type TabCategory = typeof TAB[keyof typeof TAB];

export const TAB_TO_GROUP: Partial<Record<TabCategory, string>> = {
  [TAB.OFFICE]: '오피스 공간',
  [TAB.BUILD]:  TAB.BUILD,
  [TAB.SOLO]:   TAB.SOLO,
};

export const CATEGORY_MAP = FORM_MENUS.reduce<Record<string, FormKey[]>>(
  (acc, menu) => {
    if (!menu.groupLabel) return acc;
    if (!acc[menu.groupLabel]) acc[menu.groupLabel] = [];
    acc[menu.groupLabel].push(menu.key);
    return acc;
  },
  {},
);

export function getSubCategoriesForTab(tab: TabCategory): FormKey[] {
  const groupLabel = TAB_TO_GROUP[tab];
  if (!groupLabel) return [];
  return CATEGORY_MAP[groupLabel] ?? [];
}

export const SUB_LABEL: Record<FormKey, string> = {
  ...Object.fromEntries(FORM_MENUS.map((menu) => [menu.key, menu.label])),
  [FORM_KEY.INDIVIDUAL_OFFICE]: '1인 전용 오피스',
} as Record<FormKey, string>;

function filterByTabCategory(events: HubEvent[], tab: TabCategory): HubEvent[] {
  const keys = getSubCategoriesForTab(tab);
  return events.filter((event) => keys.includes(event.category));
}

export function filterSlideEventsForTab(events: HubEvent[], tab: TabCategory): HubEvent[] {
  const active = getActiveEvents(events.filter((event) => event.slideTitle != null));
  if (tab === TAB.ALL) {
    return active.filter((event) => event.category === FORM_KEY.SHARED_OFFICE);
  }
  return filterByTabCategory(active, tab);
}

export function filterCardEventsForTab(events: HubEvent[], tab: TabCategory): HubEvent[] {
  const active = getActiveEvents(events.filter((event) => event.cardTitle != null));
  if (tab === TAB.ALL) return active;
  return filterByTabCategory(active, tab);
}
